import { Suspense } from "react"
import { useUser } from "@/apis/bff"
import { CapacityTodayShift } from "@/modules/productivity-cockpit/capacity-today-shift"
import { ObcWzChart } from "@/modules/productivity-cockpit/components/capacity-gauge-charts"

export const ProductivityCockpitCapacity = () => {
  const user = useUser()
  return (
    <Suspense fallback={null}>
      <div className="divide-border border-border bg-background-subdued grid grid-cols-1 divide-y rounded-lg border">
        <div className="flex items-center justify-evenly">
          <ObcWzChart />
        </div>
        <div className="divide-border z-0 grid grid-cols-2 divide-x">
          {user.isOneOf(["Doctor", "MedicalSupervisor", "NursingProfessional"]) && <CapacityTodayShift />}
        </div>
      </div>
    </Suspense>
  )
}
